/**
 * Cognito token helpers for BFF auth (fetch patch + WebSocket $connect).
 *
 * Amplify v6 caches tokens in localStorage; async helper prefers fetchAuthSession
 * with optional forceRefresh, then falls back to localStorage (idToken → accessToken).
 */

import { fetchAuthSession } from 'aws-amplify/auth';

function readTokenFromStorage(suffix: '.idToken' | '.accessToken'): string | null {
  try {
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key?.includes(suffix)) {
        const token = localStorage.getItem(key);
        if (token) return token;
      }
    }
  } catch {
    // localStorage not available
  }
  return null;
}

export function getCognitoTokenSync(): string | null {
  return readTokenFromStorage('.idToken') ?? readTokenFromStorage('.accessToken');
}

export async function getCognitoTokenAsync(options?: {
  forceRefresh?: boolean;
}): Promise<string | null> {
  try {
    const session = await fetchAuthSession(
      options?.forceRefresh ? { forceRefresh: true } : undefined,
    );
    const tokens = session.tokens;
    if (tokens?.idToken) return tokens.idToken.toString();
    if (tokens?.accessToken) return tokens.accessToken.toString();
  } catch {
    // ignore — fall back to storage
  }

  return getCognitoTokenSync();
}
